import { prepareZXingModule } from '@yudiel/react-qr-scanner';

const LOCAL_WASM_URL = '/assets/zxing_reader.wasm';

const CDN_WASM_URL =
  'https://fastly.jsdelivr.net/npm/zxing-wasm@2.2.1/dist/reader/zxing_reader.wasm';

async function initializeDecoder(wasmUrl: string) {
  await prepareZXingModule({
    overrides: {
      locateFile: (path: string, prefix: string) => {
        if (path.endsWith('.wasm')) {
          return wasmUrl;
        }

        return prefix + path;
      },
    },
    fireImmediately: true,
  });
}

export async function configureBarcodeDecoder() {
  try {
    // First attempt: locally hosted WASM
    await initializeDecoder(LOCAL_WASM_URL);
  } catch (localError) {
    console.warn(
      'Local ZXing initialization failed. Trying CDN fallback.',
      localError
    );

    try {
      // Second attempt: CDN-hosted WASM
      await initializeDecoder(CDN_WASM_URL);
    } catch (cdnError) {
      console.error(
        'ZXing decoder initialization failed for both local and CDN WASM.',
        { localError, cdnError }
      );

      throw cdnError;
    }
  }
}
